import api from "./api";
import qsStringify from "./qsStringify";

export const postForm = (body, endpoint) =>
  api.post(endpoint, body).then(res => res.data);

export const getPreRegistrationPage = (endpoint, locale) => {
  const query = qsStringify({
    populate: ["page_info.seo_info.image", "page_info.banner", "file"],
    locale,
  });
  return api.get(`${endpoint}?${query}`).then(res => res.data);
};
